import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommunitySpaces from './Home/CommunitySpaces';

const SubscribedCollections = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.token);

  if (!token) {
    navigate('/login');
    return null;
  }

  return (
    <CommunitySpaces
      subscribedMode={true}
      pageTitle="Subscribed Collections"
    />
  );
};

export default SubscribedCollections;
